var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "publication container html-content" },
    [
      _c(
        "div",
        { staticClass: "publication-title" },
        [
          _c("h1", [_vm._v(_vm._s(_vm.PUBLICATION.title))]),
          _c("vue-client-only", [
            _vm.adaptive.isDesktop
              ? _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("fullDate")(_vm.PUBLICATION.publishedOn)) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c("div", {
        staticClass: "publication-content",
        domProps: { innerHTML: _vm._s(_vm.PUBLICATION.body) }
      }),
      _c("publications-block", { attrs: { title: "Другие новости и акции" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }